module.exports = { domain:"messages",
  locale_data:{ messages:{ "":{ domain:"messages",
        plural_forms:"nplurals=1; plural=0;",
        lang:"zh_CN" },
      "Loading…":[ "正在加载…" ],
      "Adding…":[ "正在添加…" ],
      "Select a collection…":[ "选择一个收藏集…" ],
      "Create new collection":[ "创建新收藏集" ],
      "Added to %(collectionName)s":[ "已添加到 %(collectionName)s" ],
      "Add to…":[ "添加到…" ],
      "Edit add-on":[ "编辑附加组件" ],
      "Admin add-on":[ "管理员附加组件" ],
      "Content review add-on":[ "内容审核附加组件" ],
      "Review theme":[ "审核主题" ],
      "Review add-on code":[ "审核附加组件代码" ],
      "%(average)s (%(count)s review)":[ "" ],
      "%(average)s (%(count)s reviews)":[ "" ],
      "%(count)s User":[ "%(count)s 个用户" ],
      "No Users":[ "尚无用户" ],
      "Available on Firefox for Android™":[ "可在 Android™ 版 Firefox 上使用" ],
      Experimental:[ "实验性" ],
      "Some features may require payment":[ "某些功能可能需要付费" ],
      "This add-on is not compatible with your version of Firefox.":[ "此附加组件不兼容您的 Firefox 版本。" ],
      "This add-on is not available on your platform.":[ "此附加组件不适用您的平台。" ],
      "%(total)s user":[ "%(total)s 个用户" ],
      "Report this add-on to Mozilla":[ "向 Mozilla 报告此附加组件" ],
      "Send some feedback about the add-on":[ "发送附加组件相关反馈" ],
      "Report the add-on because it's illegal or incompliant":[ "向 Mozilla 举报某扩展违法或违规" ],
      "%(addonName)s – Get this Extension for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下载 🦊 Firefox 扩展（%(locale)s）" ],
      "%(addonName)s – Get this Language Pack for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下载 🦊 Firefox 语言包（%(locale)s）" ],
      "%(addonName)s – Get this Theme for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下载 🦊 Firefox 主题（%(locale)s）" ],
      "%(addonName)s – Get this Add-on for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下载 🦊 Firefox 附加组件（%(locale)s）" ],
      "Download %(addonName)s for Firefox. %(summary)s":[ "下载 Firefox 上的 %(addonName)s。%(summary)s" ],
      "%(addonName)s – Get this Dictionary for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下载适用于 Android 的 🦊 Firefox 字典（%(locale)s）" ],
      "%(addonName)s – Get this Extension for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下载适用于 Android 的 🦊 Firefox 扩展（%(locale)s）" ],
      "%(addonName)s – Get this Language Pack for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下载适用于 Android 的 🦊 Firefox 语言包（%(locale)s）" ],
      "%(addonName)s – Get this Theme for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下载适用于 Android 的 🦊 Firefox 主题（%(locale)s）" ],
      "%(addonName)s – Get this Add-on for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下载适用于 Android 的 🦊 Firefox 附加组件（%(locale)s）" ],
      "%(addonName)s – Get this Dictionary for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下载 🦊 Firefox 字典（%(locale)s）" ],
      Homepage:[ "主页" ],
      "Support site":[ "用户支持网站" ],
      "Support Email":[ "支持邮箱" ],
      "Visit stats dashboard":[ "前往统计面板" ],
      "Custom License":[ "自定义许可证" ],
      "%(timeFromNow)s (%(date)s)":[ "%(timeFromNow)s (%(date)s)" ],
      "Read the privacy policy for this add-on":[ "阅读此附加组件的隐私政策" ],
      "Read the license agreement for this add-on":[ "阅读此附加组件的许可协议" ],
      "See all versions":[ "查看所有版本" ],
      "Add-on Links":[ "附加组件链接" ],
      Version:[ "版本" ],
      Size:[ "大小" ],
      "Last updated":[ "上次更新" ],
      "Related Categories":[ "相关分类" ],
      License:[ "许可证" ],
      "Privacy Policy":[ "隐私政策" ],
      "End-User License Agreement":[ "最终用户许可协议" ],
      "Version History":[ "版本历史" ],
      "Usage Statistics":[ "使用统计" ],
      Tags:[ "标签" ],
      "Add to collection":[ "添加到收藏集" ],
      "Admin Links":[ "管理员链接" ],
      "Author Links":[ "作者链接" ],
      "More information":[ "更多信息" ],
      "Other users with this extension also installed":[ "此扩展的其他用户也安装了" ],
      "Other popular extensions":[ "其他流行扩展" ],
      "You reported this add-on":[ "您已举报此附加组件" ],
      "We have received your report. Thanks for letting us know about your concerns with this add-on.":[ "我们已收到您的报告。感谢您对此的关注。" ],
      "Report this add-on":[ "举报此附加组件" ],
      "Edit reply":[ "编辑回复" ],
      "Edit review":[ "编辑评价" ],
      "Delete reply":[ "删除回复" ],
      "Delete rating":[ "删除评分" ],
      "Delete review":[ "删除评价" ],
      "Do you really want to delete this reply?":[ "您确实要删除这则回复吗？" ],
      "Do you really want to delete this rating?":[ "您确实要删除这条评价吗？" ],
      "Do you really want to delete this review?":[ "您确实要删除这条评价吗？" ],
      Delete:[ "删除" ],
      Cancel:[ "取消" ],
      "Keep reply":[ "保留回复" ],
      "Keep rating":[ "保留评分" ],
      "Keep review":[ "保留评价" ],
      "Write a reply to this review.":[ "撰写对此评价的回应。" ],
      "Update reply":[ "更新回复" ],
      "Publish reply":[ "发布回复" ],
      "Updating reply":[ "更新回复" ],
      "Publishing reply":[ "回复发布中" ],
      "posted %(linkStart)s%(timestamp)s%(linkEnd)s":[ "发布于 %(linkStart)s%(timestamp)s%(linkEnd)s" ],
      "by %(linkUserProfileStart)s%(authorName)s%(linkUserProfileEnd)s, %(linkStart)s%(timestamp)s%(linkEnd)s":[ "来自 %(linkUserProfileStart)s%(authorName)s%(linkUserProfileEnd)s， %(linkStart)s%(timestamp)s%(linkEnd)s" ],
      "Deleting…":[ "正在删除…" ],
      "Reply to this review":[ "回复此评价" ],
      "This rating or review has been deleted. You are only seeing it because of elevated permissions.":[ "此评分或评价已被删除。您能看到它是因为提升的权限。" ],
      "Write a review":[ "撰写评价" ],
      "Write about your experience with this add-on.":[ "写下您使用此附加组件的体验。" ],
      "Submit review":[ "提交评价" ],
      "Submitting review":[ "正在提交评价" ],
      "Update review":[ "更新评价" ],
      "Updating review":[ "更新评价" ],
      Saving:[ "正在保存…" ],
      Saved:[ "已保存" ],
      "Please follow our %(linkStart)sreview guidelines%(linkEnd)s.":[ "请遵循我们的%(linkStart)s评价指南%(linkEnd)s。" ],
      "Your star rating:":[ "您的星级评级：" ],
      "More dictionaries by %(author)s":[ "%(author)s 制作的更多字典" ],
      "More dictionaries by these translators":[ "译者制作的更多字典" ],
      "More extensions by %(author)s":[ "%(author)s 制作的更多扩展" ],
      "More extensions by these developers":[ "开发者制作的更多扩展" ],
      "Extensions by %(author)s":[ "%(author)s 制作的扩展" ],
      "Extensions by these developers":[ "这些开发者制作的扩展" ],
      "More language packs by %(author)s":[ "%(author)s 制作的更多语言包" ],
      "More language packs by these translators":[ "译者制作的更多语言包" ],
      "More themes by %(author)s":[ "%(author)s 制作的更多主题" ],
      "More themes by these artists":[ "艺术家制作的更多主题" ],
      "Themes by %(author)s":[ "%(author)s 制作的主题" ],
      "Themes by these artists":[ "这些艺术家制作的主题" ],
      "More add-ons by %(author)s":[ "%(author)s 制作的更多附加组件" ],
      "More add-ons by these developers":[ "开发者制作的更多附加组件" ],
      "More powerful tools for translations, writing & grammar support":[ "更强大的翻译、写作和语法支持工具" ],
      "More amazing extensions to change the way Firefox looks":[ "更多改变 Firefox 外观的优质扩展" ],
      "More incredible social media extensions":[ "更多令人难以置信的社交媒体扩展" ],
      "More excellent search extensions":[ "更多优秀的搜索扩展" ],
      "More great extensions for feeds, news & media":[ "更强大的提要、新闻和媒体扩展" ],
      "More great notification extensions":[ "更多超棒的通知扩展" ],
      "More great tools for web developers":[ "更多为 Web 开发人员提供的出色工具" ],
      "See Firefox Staff Picks":[ "查看 Firefox 员工精选" ],
      "Explore our 'Starter Pack' to get started with extensions":[ "探索我们的“入门精选”，开启扩展之旅" ],
      "More powerful privacy & security extensions":[ "更强大的隐私和安全扩展" ],
      "More incredible download managers":[ "更令人难以置信的下载管理器" ],
      "More fantastic tab & bookmark extensions":[ "更多精彩的标签和书签扩展" ],
      "More great extensions for games & entertainment":[ "更多出色的游戏和娱乐扩展" ],
      "More amazing image, photo & media extensions":[ "更多令人惊叹的图像、照片和媒体扩展" ],
      "Add-on icon":[ "附加组件图标" ],
      "%(rating)s Star out of 5":[ "%(rating)s / 5 星" ],
      ",":[ "," ],
      by:[ "作者：" ],
      "Source code released under %(linkStart)s%(licenseName)s%(linkEnd)s":[ "源代码遵循 %(linkStart)s%(licenseName)s%(linkEnd)s 发布" ],
      "Source code released under %(linkStart)sCustom License%(linkEnd)s":[ "源代码遵循%(linkStart)s自定义许可证%(linkEnd)s发布" ],
      "Source code released under %(licenseName)s":[ "源代码遵循 %(licenseName)s 发布" ],
      "No version found":[ "没有找到版本" ],
      "Version %(versionNumber)s":[ "版本 %(versionNumber)s" ],
      "Released %(dateReleased)s - %(fileSize)s":[ "发布于 %(dateReleased)s - %(fileSize)s" ],
      Enable:[ "启用" ],
      Remove:[ "移除" ],
      Enabling:[ "正在启用" ],
      Disabling:[ "禁用中" ],
      Downloading:[ "正在下载" ],
      Installing:[ "正在安装" ],
      Uninstalling:[ "正在卸载" ],
      "Install Theme":[ "安装主题" ],
      "Add to Firefox":[ "添加到 Firefox" ],
      "Add-ons for Firefox (%(locale)s)":[ "Firefox 附加组件（%(locale)s）" ],
      "%(title)s – Add-ons for Firefox (%(locale)s)":[ "%(title)s – Firefox 附加组件（%(locale)s）" ],
      "Add-ons for Firefox Android (%(locale)s)":[ "适用于 Android 的 Firefox 附加组件（%(locale)s）" ],
      "%(title)s – Add-ons for Firefox Android (%(locale)s)":[ "%(title)s – 适用于 Android 的 Firefox 附加组件（%(locale)s）" ],
      "Log out":[ "退出" ],
      "Log in":[ "登录" ],
      "This action is currently unavailable. Please reload the page in a moment.":[ "此操作当前不可用，请稍后刷新页面重试。" ],
      Loading:[ "正在加载" ],
      "Find add-ons":[ "查找附加组件" ],
      Search:[ "搜索" ],
      Categories:[ "分类" ],
      "Loading categories.":[ "正在加载分类。" ],
      "No categories found.":[ "没有找到分类。" ],
      "Added to collection":[ "已添加至收藏集" ],
      "Removed from collection":[ "已从收藏集中移除" ],
      "Find an add-on to include in this collection":[ "搜索附加组件并加入此收藏集" ],
      "Edit this collection":[ "编辑此收藏集" ],
      "Edit collection details":[ "编辑收藏集信息" ],
      "Back to collection":[ "返回收藏集" ],
      "Add-ons":[ "附加组件" ],
      Creator:[ "作者" ],
      "Create collection":[ "创建收藏集" ],
      "Save changes":[ "保存更改" ],
      "Collection name":[ "收藏集名称" ],
      Description:[ "描述" ],
      "Custom URL":[ "自定义网址" ],
      "Sort add-ons by":[ "排序附加组件，按" ],
      "Newest first":[ "最新在前" ],
      "Oldest first":[ "最早在前" ],
      Name:[ "名称" ],
      Popularity:[ "热门度" ],
      Confirm:[ "确认" ],
      "Contribute now":[ "我要捐款" ],
      "Support this developer":[ "支持这位开发者" ],
      "Support these developers":[ "支持这些开发者" ],
      "The developer of this extension asks that you help support its continued development by making a small contribution.":[ "此扩展的开发者寻求您的小小捐助以支持其持续发展。" ],
      "The developers of this extension ask that you help support its continued development by making a small contribution.":[ "此扩展的开发者寻求您的小小捐助以支持其持续发展。" ],
      "Support this artist":[ "支持这位作者" ],
      "Support these artists":[ "支持这些作者" ],
      "The artist of this theme asks that you help support its continued creation by making a small contribution.":[ "此主题的创作者寻求您的小小捐助以支持其继续创作。" ],
      "The artists of this theme ask that you help support its continued creation by making a small contribution.":[ "此主题的创作者寻求您的小小捐助以支持其继续创作。" ],
      "Support this author":[ "支持这位作者" ],
      "Support these authors":[ "支持这些作者" ],
      "The author of this add-on asks that you help support its continued work by making a small contribution.":[ "此附加组件的作者寻求您的小小捐助以支持其继续创造。" ],
      "The authors of this add-on ask that you help support its continued work by making a small contribution.":[ "此附加组件的作者寻求您的小小捐助以支持其继续创造。" ],
      "Enter text.":[ "输入文本。" ],
      Submit:[ "提交" ],
      Submitting:[ "正在提交" ],
      "Leave a note":[ "留下注释" ],
      "Collector's note":[ "收藏者说明" ],
      "Add a comment about this add-on.":[ "添加对此附加组件的评论。" ],
      Save:[ "保存" ],
      Edit:[ "编辑" ],
      "Your session has expired":[ "您的会话已过期" ],
      "An unexpected error occurred":[ "发生意外错误" ],
      "Reload To Continue":[ "重新加载以继续" ],
      "Page not found":[ "找不到页面" ],
      "Sorry, but we can't find anything at the URL you entered.":[ "很抱歉，但我们无法用您输入的地址找到信息。" ],
      "Error code: %(status)s.":[ "错误代码：%(status)s。" ],
      "Login authentication has expired. %(startLink)sReload the page%(endLink)s to continue without authentication, or login again using the Log In link at the top of the page.":[ "登录验证已过期。%(startLink)s请刷新页面%(endLink)s以在未验证状态下继续浏览，或点击页面顶部的“登录”链接重新登录。" ],
      "Login Expired":[ "登录已过期" ],
      "If you are signed in and think this message is an error, please <a href=\"%(url)s\">file an issue</a>. Tell us where you came from and what you were trying to access, and we'll fix the issue.":[ "若您已登录，认为这个提示有误，请<a href=\"%(url)s\">填报问题</a>。填报时请提及您是从哪个网址过来的、想访问什么内容，我们将修正此问题。" ],
      "Not Authorized":[ "尚未授权" ],
      "Sorry, but you aren't authorized to access this page. If you aren't signed in, try signing in using the link at the top of the page.":[ "很抱歉，但您无权访问此页面。如果您尚未登录，请使用页面顶部的链接登录。" ],
      "Try visiting the page later, as the theme or extension may become available again. Alternatively, you may be able to find what you’re looking for in one of the available %(extensionStart)sextensions%(extensionEnd)s or %(themeStart)sthemes%(themeEnd)s, or by asking for help on our %(communityStart)scommunity forums%(communityEnd)s.":[ "请过段时间后再尝试访问该页面，因为主题或扩展可能会再次上架。另外，也许您可以在下列%(extensionStart)s扩展%(extensionEnd)s或%(themeStart)s主题%(themeEnd)s中找到要您要找的内容，或者到我们的%(communityStart)s社区论坛%(communityEnd)s寻求帮助。" ],
      "Oops! We can’t find that page":[ "哎呀！我们找不到那个页面" ],
      "If you’ve followed a link from another site for an extension or theme, that item is no longer available. This could be because:":[ "如果您是点击其他网站上的链接而来，想寻找某个扩展或主题，该项目却已不可用。这可能是因为：" ],
      "The developer removed it. Developers commonly do this because they no longer support the extension or theme, or have replaced it.":[ "开发者主动下架。他们通常会因为不再支持该扩展或主题，或已推出替代版本而这么做。" ],
      "Mozilla removed it. This can happen when issues are found during the review of the extension or theme, or the extension or theme has been abusing the terms and conditions for addons.mozilla.org. The developer has the opportunity to resolve the issues and make the add-on available again.":[ "Mozilla 已将其下架。这可能是因为在审核扩展或主题的过程中发现问题，或是该扩展或主题违反了 addons.mozilla.org 的使用条款和条件。开发者会有机会解决问题，并重新上架。" ],
      "If you have additional information that would help us you can <a href=\"https://github.com/mozilla/addons-frontend/issues/new/\">file an issue</a>. Tell us what steps you took that lead to the error and we'll do our best to fix it.":[ "如果您有其他能够帮助我们修正问题的信息，请<a href=\"https://github.com/mozilla/addons-frontend/issues/new/\">填报问题</a>。在填报时中请告诉我们您做了哪些事情后发生了错误，我们将尽力修正。" ],
      "Server Error":[ "服务器错误" ],
      "Sorry, but there was an error with our server and we couldn't complete your request. We have logged this error and will investigate it.":[ "很抱歉，但目前遇到一个服务器错误，我们无法完成您的请求。我们已记录该错误，并会进行调查。" ],
      "You may be able to find what you’re looking for in one of the available %(extensionStart)sextensions%(extensionEnd)s or %(themeStart)sthemes%(themeEnd)s, or by asking for help on our %(communityStart)scommunity forums%(communityEnd)s.":[ "您可以在下列%(extensionStart)s扩展%(extensionEnd)s或%(themeStart)s主题%(themeEnd)s中找到要您要找的内容，或者到我们的%(communityStart)s社区论坛%(communityEnd)s寻求帮助。" ],
      "That page is not available in your region":[ "此页面在您的地区不可用" ],
      "The page you tried to access is not available in your region.":[ "您尝试访问的页面在您的地区不可用。" ],
      "Toggle contents":[ "切换内容" ],
      "Response by %(userName)s":[ "%(userName)s 的回应" ],
      "Review by %(userName)s":[ "%(userName)s 的评价" ],
      "The review was not found.":[ "未找到此评价。" ],
      "By submitting this report I certify, under penalty of perjury, that the allegations it contains are complete and accurate, to the best of my knowledge.":[ "提交此报告即代表我确认报告中的指控是完整且准确的，如有伪证将受法律约束。" ],
      "It doesn’t work, breaks websites, or slows down Firefox":[ "无法正常使用、造成网站异常、拖慢 Firefox 运行速度" ],
      "Example: Features are slow, hard to use, or don’t work; parts of websites won't load or look unusual.":[ "示例：功能运行缓慢、难以使用或不起作用；部分网站无法加载或看起来不正常。" ],
      "It’s spam":[ "垃圾信息" ],
      "Example: The listing advertises unrelated products or services.":[ "例如：列表中宣传无关的产品或服务。" ],
      "It violates Add-on Policies":[ "违反附加组件政策" ],
      "Example: It compromised my data without informing or asking me, or it changed my search engine or home page without informing or asking me.":[ "例如：未经告知或询问即泄露我的数据，或者未经告知或询问即更改我的搜索引擎或主页。" ],
      "It contains hateful, violent, deceptive, or other inappropriate content":[ "包含仇恨、暴力、诈骗等不当内容" ],
      "Example: It contains racist imagery.":[ "例如：包含种族歧视的图像。" ],
      "It violates the law or contains content that violates the law":[ "存在违法行为或包含违法内容" ],
      "Example: Fraud. (If you wish to report a copyright or trademark infringement, you can learn more about how to do so in our %(startLink)sCopyright or Trademark Infringement Reporting article%(endLink)s).":[ "例如：欺诈。（若要举报版权或商标侵权，可阅读%(startLink)s举报版权或商标侵权文章%(endLink)s，详细了解举报方法）。" ],
      "Something else":[ "其他情形" ],
      "Anything that doesn’t fit into the other categories.":[ "任何不适合其他分类的情形。" ],
      "Select place":[ "选择位置" ],
      "On the add-on's page on this website":[ "此网站的附加组件页面" ],
      "Inside the add-on":[ "附加组件内部" ],
      "Both locations":[ "两处皆有" ],
      "Select type":[ "选择类型" ],
      "Animal welfare":[ "动物福利" ],
      "Consumer information infringements":[ "侵犯消费者个人信息权" ],
      "Data protection and privacy violations":[ "侵害数据保护和隐私权" ],
      "Illegal or harmful speech":[ "违法或有害言论" ],
      "Intellectual property infringements":[ "侵犯知识产权" ],
      "Negative effects on civic discourse or elections":[ "对公民话语权或选举产生负面影响" ],
      "Non-consensual behavior":[ "未经同意的行为" ],
      "Pornography or sexualized content":[ "色情或性暗示内容" ],
      "Protection of minors":[ "未成年人保护" ],
      "Risk for public security":[ "公共安全风险" ],
      "Scams or fraud":[ "诈骗或欺诈内容" ],
      "Self-harm":[ "自残" ],
      "Unsafe, non-compliant, or prohibited products":[ "不安全、不合规或受禁止的产品" ],
      Violence:[ "暴力内容" ],
      Other:[ "其他" ],
      "Select violation":[ "选择违规类型" ],
      "Insufficient information on traders":[ "交易者相关信息不完善" ],
      "Non-compliance with pricing regulations":[ "违反定价规则" ],
      "Hidden advertisement or commercial communication, including by influencers":[ "隐藏的广告或商业性传播内容（包括网红内容）" ],
      "Misleading information about the characteristics of the goods and services":[ "关于商品或服务的误导性信息" ],
      "Misleading information about the consumer’s rights":[ "对消费者权益产生误导的信息" ],
      "Biometric data breach":[ "生物识别数据外泄" ],
      "Missing processing ground for data":[ "缺少数据处理的理由" ],
      "Right to be forgotten":[ "被遗忘权" ],
      "Data falsification":[ "篡改数据" ],
      Defamation:[ "诽谤" ],
      Discrimination:[ "歧视" ],
      "Illegal incitement to violence and hatred based on protected characteristics (hate speech)":[ "非法煽动对受保护身份要素的暴力与仇恨（仇恨言论）" ],
      "Design infringements":[ "侵犯设计内容" ],
      "Geographical indications infringements":[ "侵犯地理标志信息" ],
      "Patent infringements":[ "侵犯专利权" ],
      "Trade secret infringements":[ "侵犯商业秘密" ],
      "Violation of EU law relevant to civic discourse or elections":[ "违反与公民话语权或选举相关的欧盟法律" ],
      "Violation of national law relevant to civic discourse or elections":[ "违反与公民话语权或选举相关的国家法律" ],
      "Misinformation, disinformation, foreign information manipulation and interference":[ "错误信息、虚假信息、来自外国的信息操纵与干涉" ],
      "Non-consensual image sharing":[ "未经同意共享图像" ],
      "Non-consensual items containing deepfake or similar technology using a third party's features":[ "未经同意，使用第三方软件开发包含 Deepfake 或类似技术的內容" ],
      "Online bullying/intimidation":[ "网络霸凌、恐吓" ],
      Stalking:[ "非法跟踪骚扰" ],
      "Adult sexual material":[ "成人色情内容" ],
      "Image-based sexual abuse (excluding content depicting minors)":[ "寓于图像的性虐待（不含描绘未成年人的内容）" ],
      "age-specific restrictions concerning minors":[ "对未成年人的年龄限制" ],
      "Child sexual abuse material":[ "儿童性虐待内容" ],
      "Grooming/sexual enticement of minors":[ "对未成年人进行性诱骗" ],
      "Illegal organizations":[ "非法组织" ],
      "Risk for environmental damage":[ "环境破坏风险" ],
      "Risk for public health":[ "公共卫生风险" ],
      "Terrorist content":[ "恐怖主义内容" ],
      "Inauthentic accounts":[ "虚假账户" ],
      "Inauthentic listings":[ "虚假信息" ],
      "Inauthentic user reviews":[ "虚假评价" ],
      "Impersonation or account hijacking":[ "冒充他人或盗用账户" ],
      Phishing:[ "钓鱼内容" ],
      "Pyramid schemes":[ "传销" ],
      "Content promoting eating disorders":[ "传播导致饮食失调的内容" ],
      "Self-mutilation":[ "自残" ],
      Suicide:[ "自杀" ],
      "Prohibited or restricted products":[ "被禁止或限制使用的产品" ],
      "Unsafe or non-compliant products":[ "不安全或不合规的产品" ],
      "Coordinated harm":[ "配合实施伤害" ],
      "Gender-based violence":[ "性別暴力" ],
      "Human exploitation":[ "剥削" ],
      "Human trafficking":[ "贩卖人口" ],
      "General calls or incitement to violence and/or hatred":[ "宣扬或煽动暴力和/或仇恨" ],
      "Report submitted":[ "报告已提交" ],
      "We have received your report. Thanks for letting us know.":[ "感谢反馈，我们已收到您的报告。" ],
      "Submitting your report…":[ "正在提交报告…" ],
      "Submit report":[ "提交报告" ],
      "Provide more information":[ "提供更多信息" ],
      "Place of the violation":[ "违规地点" ],
      "Type of illegal content":[ "非法内容" ],
      "Specific violation":[ "违规情形" ],
      "Provide more details":[ "提供更多详情" ],
      "Please provide any additional information that may help us to understand your report (including which policy you believe has been violated).":[ "请提供有助于我们理清此次举报的附加信息（包括您认为其违反的政策）。" ],
      "Contact information":[ "联系方式" ],
      "File report anonymously":[ "匿名提交举报" ],
      "Filing an anonymous report will prevent us from communicating with you about the report’s status, or about any options for appeal.":[ "若匿名提交举报，我们将无法向您告知举报的处理进展，您也无法再对处理结果提出申诉。" ],
      "Your name %(spanStart)s(optional)%(spanEnd)s":[ "您的名称%(spanStart)s（选填）%(spanEnd)s" ],
      "Your name %(spanStart)s(required)%(spanEnd)s":[ "您的名称%(spanStart)s（必填）%(spanEnd)s" ],
      "Your email address %(spanStart)s(optional)%(spanEnd)s":[ "您的邮箱地址%(spanStart)s（选填）%(spanEnd)s" ],
      "Your email address %(spanStart)s(required)%(spanEnd)s":[ "您的邮箱地址%(spanStart)s（必填）%(spanEnd)s" ],
      "Content that is illegal or that violates AMO's content policies":[ "非法或违反 AMO 内容政策的内容" ],
      Flagged:[ "已标记" ],
      Flag:[ "标记" ],
      "Flag this developer response":[ "报告此开发者回应需被处理" ],
      "Flag this review":[ "报告此评价需被处理" ],
      Spam:[ "垃圾" ],
      "Flagged as spam":[ "已标记为垃圾信息" ],
      "Login required":[ "需要登录" ],
      "Misplaced bug report or support request":[ "误发的缺陷报告或支持请求" ],
      "Flagged as misplaced bug report or support request":[ "已标记为误发的缺陷报告或支持请求" ],
      "Developer Policies":[ "开发者政策" ],
      "Community Blog":[ "社区博客" ],
      Forum:[ "论坛" ],
      "Report a bug":[ "报告缺陷" ],
      "Review Guide":[ "评价指南" ],
      Browsers:[ "浏览器" ],
      Products:[ "产品" ],
      Privacy:[ "隐私" ],
      Cookies:[ "Cookie" ],
      Legal:[ "法律" ],
      "Except where otherwise %(startNotedLink)snoted%(endNotedLink)s, content on this site is licensed under the %(startLicenseLink)sCreative Commons Attribution Share-Alike License v3.0%(endLicenseLink)s or any later version. Android is a trademark of Google LLC.":[ "本站内容以%(startLicenseLink)s知识共享署名-相同方式共享 v3.0%(endLicenseLink)s 或任何更新版本授权（除非另有%(startNotedLink)s注明%(endNotedLink)s）。Android 系 Google LLC 的商标。" ],
      "Except where otherwise %(startNotedLink)snoted%(endNotedLink)s, content on this site is licensed under the %(startLicenseLink)sCreative Commons Attribution Share-Alike License v3.0%(endLicenseLink)s or any later version.":[ "除非另有%(startNotedLink)s注明%(endNotedLink)s，否则本网站上的内容可按%(startLicenseLink)s知识共享 署名-相同方式共享 3.0%(endLicenseLink)s 或更新版本使用。" ],
      "Go to Mozilla's homepage":[ "转至 Mozilla 主页" ],
      About:[ "关于" ],
      "Firefox Add-ons Blog":[ "Firefox 附加组件博客" ],
      "Extension Workshop":[ "扩展工坊" ],
      "Developer Hub":[ "开发者中心" ],
      "To use these add-ons, you'll need to %(downloadLinkStart)sdownload Firefox%(downloadLinkEnd)s.":[ "需要%(downloadLinkStart)s下载 Firefox%(downloadLinkEnd)s 才能使用这些附加组件。" ],
      "To use Android extensions, you'll need %(downloadLinkStart)sFirefox for Android%(downloadLinkEnd)s. To explore Firefox for desktop add-ons, please %(linkStart)svisit our desktop site%(linkEnd)s.":[ "Android 版扩展只能在 %(downloadLinkStart)sAndroid 版 Firefox%(downloadLinkEnd)s 上使用。若要探索桌面版 Firefox 附加组件，请%(linkStart)s访问桌面版网站%(linkEnd)s。" ],
      "Download Firefox and get the theme":[ "下载 Firefox 并安装主题" ],
      "Download Firefox and get the extension":[ "下载 Firefox 并安装扩展" ],
      "Download the new Firefox and get the theme":[ "下载新版 Firefox 并安装主题" ],
      "Download the new Firefox and get the extension":[ "下载新版 Firefox 并安装扩展" ],
      "Download Firefox":[ "下载 Firefox" ],
      "You'll need Firefox to use this theme":[ "您需要 Firefox 来使用此主题" ],
      "You'll need Firefox to use this extension":[ "您需要 Firefox 来使用此扩展" ],
      "You need an updated version of Firefox for this theme":[ "您需要更新 Firefox 来使用此主题" ],
      "You need an updated version of Firefox for this extension":[ "您需要更新 Firefox 来使用此扩展" ],
      Tools:[ "工具" ],
      "Submit a New Add-on":[ "提交新附加组件" ],
      "Submit a New Theme":[ "提交新主题" ],
      "Manage My Submissions":[ "管理我的提交" ],
      "Reviewer Tools":[ "审核员工具" ],
      "Firefox Browser Add-ons":[ "Firefox 浏览器附加组件" ],
      "Learn how to create extensions and themes":[ "了解如何创建扩展和主题" ],
      "Submit and manage extensions and themes":[ "提交和管理扩展和主题" ],
      "My Account":[ "我的账户" ],
      "View My Collections":[ "查看我的收藏集" ],
      "View My Profile":[ "查看我的个人资料" ],
      "Edit My Profile":[ "编辑我的个人资料" ],
      "Get the extension":[ "安装扩展" ],
      RECOMMENDED:[ "推荐" ],
      "BY FIREFOX":[ "Firefox 出品" ],
      PROMOTED:[ "推广" ],
      "Firefox only recommends extensions that meet our standards for security and performance.":[ "Firefox 只推荐符合我们的安全和性能标准的扩展。" ],
      "See more %(categoryName)s":[ "浏览更多 %(categoryName)s 结果" ],
      "Access your data for all websites":[ "访问您在所有网站的数据" ],
      "Access your data for sites in the %(param)s domain":[ "访问您在 %(param)s 域名的数据" ],
      "Access your data for %(param)s":[ "访问您在 %(param)s 的数据" ],
      "Download file":[ "下载文件" ],
      "Learn more":[ "详细了解" ],
      "This add-on is not actively monitored for security by Mozilla. Make sure you trust it before installing.":[ "此附加组件未经 Mozilla 主动安全审计，安装前请确认您对其信任。" ],
      "Change language":[ "更改语言" ],
      "Dismiss this notice":[ "忽略此通知" ],
      Previous:[ "上一页" ],
      Next:[ "下一页" ],
      "Page %(thisPage)s of %(totalPages)s":[ "第 %(thisPage)s 页，共 %(totalPages)s 页" ],
      "Required permissions:":[ "必要权限：" ],
      "Optional permissions:":[ "可选权限：" ],
      "Optional data collection, according to the developer:":[ "根据开发者所述，可选的数据收集有：" ],
      "Data collection:":[ "收集的数据：" ],
      "Required data collection, according to the developer:":[ "根据开发者所述，必要的数据收集：" ],
      "Permissions and data":[ "权限与数据" ],
      "Read and modify bookmarks":[ "读取和修改书签" ],
      "Read and modify browser settings":[ "读取和修改浏览器设置" ],
      "Clear recent browsing history, cookies, and related data":[ "清除最近的浏览历史、Cookie 及有关数据" ],
      "Get data from the clipboard":[ "获取剪贴板数据" ],
      "Input data to the clipboard":[ "输入数据到剪贴板" ],
      "Block content on any page":[ "拦截任何页面上的内容" ],
      "Read your browsing history":[ "读取您的浏览历史" ],
      "Extend developer tools to access your data in open tabs":[ "让开发者工具可以存取您打开的标签页中的数据" ],
      "Download files and read and modify the browser’s download history":[ "下载文件和读取与修改浏览器的下载历史" ],
      "Open files downloaded to your computer":[ "打开已下载至您的计算机的文件" ],
      "Read the text of all open tabs":[ "读取所有已打开的标签页中的文本" ],
      "Access your location":[ "获知您的位置" ],
      "Access browsing history":[ "获取浏览历史" ],
      "Monitor extension usage and manage themes":[ "监控扩展使用情况和管理主题" ],
      "Exchange messages with programs other than Firefox":[ "与 Firefox 之外的其他程序交换信息" ],
      "Display notifications to you":[ "为您显示通知" ],
      "Provide cryptographic authentication services":[ "提供密码认证服务" ],
      "Control browser proxy settings":[ "控制浏览器的代理设置" ],
      "Read and modify privacy settings":[ "读取和修改隐私设置" ],
      "Access recently closed tabs":[ "获取最近关闭的标签页" ],
      "Access browser tabs":[ "获取浏览器标签页" ],
      "Hide and show browser tabs":[ "隐藏和显示浏览器标签页" ],
      "Access browser activity during navigation":[ "获知浏览器导航时的行为状态" ],
      "Authentication information":[ "身份验证信息" ],
      Bookmarks:[ "书签" ],
      "Browsing activity":[ "浏览活动" ],
      "Financial and payment information":[ "财务和付款信息" ],
      "Health information":[ "健康信息" ],
      Location:[ "地址" ],
      "Personal communications":[ "个人通信" ],
      "Personally identifying information":[ "个人身份信息" ],
      "Search terms":[ "搜索词" ],
      "Technical and interaction data":[ "技术和交互数据" ],
      "Website activity":[ "网站活动" ],
      "Website content":[ "网站内容" ],
      "The developer says this extension doesn't require data collection.":[ "开发者称此扩展无需收集数据。" ],
      "Rated %(rating)s out of 5":[ "评分 %(rating)s / 5" ],
      "Update your rating to %(starRating)s out of 5":[ "更新您的评分为 %(starRating)s / 5" ],
      "Rate this add-on %(starRating)s out of 5":[ "为此附加组件评分 %(starRating)s / 5" ],
      "There are no ratings yet":[ "目前尚无评分" ],
      "Log in to rate this dictionary":[ "登录以评价此词典" ],
      "Log in to rate this language pack":[ "登录以评价此语言包" ],
      "Log in to rate this theme":[ "登录以评价此主题" ],
      "Log in to rate this extension":[ "登录以评价此扩展" ],
      "Log in to rate this add-on":[ "登录以评价此附加组件" ],
      "Are you sure you want to delete your review of %(addonName)s?":[ "您确实要删除您对于 %(addonName)s 的评价吗？" ],
      "Are you sure you want to delete your rating of %(addonName)s?":[ "您确实要删除您对于 %(addonName)s 的评分吗？" ],
      "Click to rate:":[ "点击打分：" ],
      "Saving star rating":[ "保存评分" ],
      "Star rating saved":[ "已保存星级评分" ],
      "There are no three-star reviews":[ "目前尚无三星评价" ],
      "Read the 1 two-star review":[ "阅读所有二星评价（%(total)s 条）" ],
      "There are no two-star reviews":[ "目前尚无二星评价" ],
      "Read the 1 one-star review":[ "阅读所有一星评价（%(total)s 条）" ],
      "There are no one-star reviews":[ "目前尚无一星评价" ],
      "There are no reviews":[ "目前尚无评价" ],
      "Read the 1 five-star review":[ "阅读所有五星评价（%(total)s 条）" ],
      "There are no five-star reviews":[ "目前尚无五星评价" ],
      "Read the 1 four-star review":[ "阅读所有四星评价（%(total)s 条）" ],
      "There are no four-star reviews":[ "目前尚无四星评价" ],
      "Read the 1 three-star review":[ "阅读所有三星评价（%(total)s 条）" ],
      "You reported this user":[ "您已举报此用户" ],
      "We have received your report. Thanks for letting us know about your concerns with this user.":[ "我们已收到您的报告。感谢告知。" ],
      "Report this user":[ "举报此用户" ],
      "Search results":[ "搜索结果" ],
      "Recommended extensions":[ "推荐扩展" ],
      "Recommended themes":[ "推荐主题" ],
      "Recommended add-ons":[ "推荐附加组件" ],
      "Extensions by Firefox":[ "Firefox 制作的扩展" ],
      "Themes by Firefox":[ "Firefox 制作的主题" ],
      "Add-ons by Firefox":[ "Firefox 制作的附加组件" ],
      "Reviewed extensions":[ "已审核的扩展" ],
      "Reviewed themes":[ "已审核的主题" ],
      "Reviewed add-ons":[ "已审核的附加组件" ],
      "Trending extensions":[ "热门扩展" ],
      "Trending themes":[ "热门主题" ],
      "Trending add-ons":[ "热门附加组件" ],
      "Top rated extensions":[ "好评扩展" ],
      "Top rated themes":[ "最受好评的主题" ],
      "Top rated add-ons":[ "好评附加组件" ],
      "Popular extensions":[ "最流行的扩展" ],
      "Popular themes":[ "最流行的主题" ],
      "Popular add-ons":[ "最流行的附加组件" ],
      "Search results for \"%(query)s\"":[ "“%(query)s”的搜索结果" ],
      "%(count)s extension found for \"%(query)s\"":[ "找到 %(count)s 个有关“%(query)s”的扩展" ],
      "%(count)s extension found with tag %(tag)s":[ "标签 %(tag)s 中找到 %(count)s 个扩展" ],
      "%(count)s extension found":[ "找到 %(count)s 个扩展" ],
      "%(count)s theme found for \"%(query)s\" with tag %(tag)s in %(categoryName)s":[ "分类 %(categoryName)s 中找到“%(query)s”含 %(tag)s 标签的 %(count)s 个主题" ],
      "%(count)s theme found for \"%(query)s\" in %(categoryName)s":[ "分类 %(categoryName)s 中找到 %(count)s 个有关“%(query)s”的主题" ],
      "%(count)s theme found with tag %(tag)s in %(categoryName)s":[ "分类 %(categoryName)s 中找到含 %(tag)s 标签的 %(count)s 个主题" ],
      "%(count)s theme found in %(categoryName)s":[ "分类 %(categoryName)s 中找到 %(count)s 个主题" ],
      "%(count)s theme found for \"%(query)s\" with tag %(tag)s":[ "找到“%(query)s”含 %(tag)s 标签的 %(count)s 个主题" ],
      "%(count)s theme found for \"%(query)s\"":[ "找到 %(count)s 个有关“%(query)s”的主题" ],
      "%(count)s theme found with tag %(tag)s":[ "标签 %(tag)s 中找到 %(count)s 个主题" ],
      "%(count)s theme found":[ "找到 %(count)s 个主题" ],
      "%(count)s result found for \"%(query)s\" with tag %(tag)s":[ "找到“%(query)s”含 %(tag)s 标签的 %(count)s 个结果" ],
      "%(count)s result found for \"%(query)s\"":[ "找到 %(count)s 条有关“%(query)s”的结果" ],
      "%(count)s result found with tag %(tag)s":[ "标签 %(tag)s 中找到 %(count)s 个结果" ],
      "%(count)s result found":[ "找到 %(count)s 条结果" ],
      "Searching for \"%(query)s\"":[ "搜索“%(query)s”" ],
      "Searching for add-ons":[ "正在搜索附加组件" ],
      "%(count)s extension found for \"%(query)s\" with tag %(tag)s in %(categoryName)s":[ "分类 %(categoryName)s 中找到“%(query)s”含 %(tag)s 标签的 %(count)s 个扩展" ],
      "%(count)s extension found for \"%(query)s\" in %(categoryName)s":[ "分类 %(categoryName)s 中找到 %(count)s 个有关“%(query)s”的扩展" ],
      "%(count)s extension found with tag %(tag)s in %(categoryName)s":[ "分类 %(categoryName)s 中找到含 %(tag)s 标签的 %(count)s 个扩展" ],
      "%(count)s extension found in %(categoryName)s":[ "分类 %(categoryName)s 中找到 %(count)s 个扩展" ],
      "%(count)s extension found for \"%(query)s\" with tag %(tag)s":[ "找到“%(query)s”含 %(tag)s 标签的 %(count)s 个扩展" ],
      All:[ "所有" ],
      Extension:[ "扩展" ],
      Theme:[ "主题" ],
      Relevance:[ "相关性" ],
      "Recently Updated":[ "最近更新" ],
      "Most Users":[ "最多用户" ],
      "Top Rated":[ "最高评分" ],
      Trending:[ "热门" ],
      Any:[ "任何" ],
      Recommended:[ "推荐" ],
      "By Firefox":[ "Firefox 出品" ],
      "All Reviewed":[ "全部已审核项目" ],
      Black:[ "黑色" ],
      Gray:[ "灰色" ],
      White:[ "白色" ],
      Red:[ "红色" ],
      Yellow:[ "黄色" ],
      Green:[ "绿色" ],
      Cyan:[ "青色" ],
      Blue:[ "蓝色" ],
      Magenta:[ "品红色" ],
      "Filter results":[ "过滤结果" ],
      "Sort by":[ "排序方式" ],
      "Add-on Type":[ "附加组件类型" ],
      "Theme Color":[ "主题色" ],
      Clear:[ "清除" ],
      Badging:[ "徽章" ],
      "Firefox Add-ons for Android":[ "适用于 Android 的 Firefox 附加组件" ],
      "Firefox Add-ons":[ "Firefox 附加组件" ],
      "Go to the add-on page":[ "访问附加组件页面" ],
      "No theme preview available":[ "无主题预览可用" ],
      "Add-on note":[ "附加组件说明" ],
      "Searching…":[ "正在搜索…" ],
      "No results were found for \"%(query)s\".":[ "搜索“%(query)s”没有找到结果。" ],
      "No results were found.":[ "没有找到结果。" ],
      Themes:[ "主题" ],
      "More…":[ "更多…" ],
      "for Firefox":[ "适用于 Firefox" ],
      "Dictionaries & Language Packs":[ "字典和语言包" ],
      "Other Browser Sites":[ "其他浏览器网站" ],
      "Add-ons for Android":[ "适用于 Android 的附加组件" ],
      Extensions:[ "扩展" ],
      "Expand to read more":[ "展开阅读更多内容" ],
      "<span class=\"visually-hidden\">Expand to</span> Read more":[ "<span class=\"visually-hidden\">展开以</span>阅读全文" ],
      "Signed in as %(username)s":[ "已作为 %(username)s 身份登录" ],
      "Some features are temporarily disabled while we perform website maintenance. We'll be back to full capacity shortly.":[ "在我们进行网站维护时，某些功能会被暂时禁用。我们将很快恢复全部功能。" ],
      "You have been logged out.":[ "您已退出登录。" ],
      "Suggested Pages":[ "推荐页面" ],
      "Browse all extensions":[ "浏览所有扩展" ],
      "Browse all themes":[ "浏览所有主题" ],
      "Add-ons Home Page":[ "附加组件首页" ],
      "Preview of %(title)s":[ "%(title)s 预览" ],
      "%(total)s add-on":[ "共 %(total)s 个附加组件" ],
      "Do you really want to delete this picture?":[ "您确实要删除这张照片吗？" ],
      "Delete This Picture":[ "删除此照片" ],
      "Profile picture for %(name)s":[ "%(name)s 的个人资料照片" ],
      "Profile photo":[ "个人资料照片" ],
      "Choose Photo…":[ "选择照片…" ],
      "Developer response":[ "开发者回应" ],
      "Save 50% with a full year subscription":[ "一次性订阅全年，可享半价" ],
      "Protect your online data—and choose a VPN subscription plan that works for you.":[ "保护您的在线数据——请选择适合您的 VPN 订阅方案。" ],
      "Get Mozilla VPN":[ "获取 Mozilla VPN" ],
      "To find extensions compatible with Firefox for Android, %(linkStart)sclick here%(linkEnd)s.":[ "%(linkStart)s点击此处%(linkEnd)s寻找 Android 版 Firefox 扩展。" ],
      "Add-ons are not compatible with Firefox for iOS. Try installing them on Firefox for desktop.":[ "附加组件不兼容于 iOS 版 Firefox。请尝试在桌面版 Firefox 上安装。" ],
      "%(localizedSize)s B":[ "%(localizedSize)s B" ],
      "%(localizedSize)s KB":[ "%(localizedSize)s KB" ],
      "%(localizedSize)s MB":[ "%(localizedSize)s MB" ],
      "%(localizedSize)s GB":[ "%(localizedSize)s GB" ],
      "%(localizedSize)s TB":[ "%(localizedSize)s TB" ],
      "This add-on cannot be rated because no versions have been published.":[ "因为还未公开发布任何版本，无法对此附加组件评分。" ],
      "Read %(count)s review":[ "阅读全部 %(count)s 条评价" ],
      "No reviews yet":[ "尚无评价" ],
      "Rated %(ratingAverage)s by 1 reviewer":[ "评分 %(ratingAverage)s（1 位用户）" ],
      "About this dictionary":[ "关于此词典" ],
      "About this extension":[ "关于此扩展" ],
      "About this language pack":[ "关于此语言包" ],
      "About this theme":[ "关于此主题" ],
      "About this add-on":[ "关于此附加组件" ],
      "Developer comments":[ "开发者留言" ],
      "Release notes for %(addonVersion)s":[ "%(addonVersion)s 的发布说明" ],
      "This is not a public listing. You are only seeing it because of elevated permissions.":[ "它没有被公开上架。您能看到它是因为提升的权限。" ],
      "Extension Metadata":[ "扩展元数据" ],
      Screenshots:[ "屏幕截图" ],
      "Submit feedback or report an add-on to Mozilla":[ "向 Mozilla 提交反馈或举报附加组件" ],
      "Custom License for %(addonName)s":[ "%(addonName)s 的自定义许可证" ],
      "End-User License Agreement for %(addonName)s":[ "%(addonName)s 的最终用户许可协议" ],
      "Privacy policy for %(addonName)s":[ "%(addonName)s 的隐私政策" ],
      "Reviews and ratings for %(addonName)s. Find out what other users think about %(addonName)s and add it to your Firefox Browser.":[ "%(addonName)s 的评价与评分。看看其他的用户觉得 %(addonName)s 如何，再安装进您的 Firefox 浏览器。" ],
      "Show all reviews":[ "显示所有评价" ],
      "Show only five-star reviews":[ "仅显示五星评价" ],
      "Show only four-star reviews":[ "仅显示四星评价" ],
      "Show only three-star reviews":[ "仅显示三星评价" ],
      "Show only two-star reviews":[ "仅显示二星评价" ],
      "Show only one-star reviews":[ "仅显示一星评价" ],
      "Reviews for %(addonName)s":[ "%(addonName)s 的评价" ],
      "%(total)s review":[ "%(total)s 条评价" ],
      "%(addonName)s version history - %(total)s version":[ "%(addonName)s 版本历史 - %(total)s 个版本" ],
      "Be careful with old versions! These versions are displayed for testing and reference purposes.":[ "小心旧版本！显示这些版本是为了测试和参考目的。" ],
      "You should always use the latest version of an add-on.":[ "您应该始终使用附加组件的最新版本。" ],
      Versions:[ "版本" ],
      "Latest version":[ "最新版本" ],
      "Older versions":[ "较早版本" ],
      "%(addonName)s is restricted for violating Mozilla policies":[ "“%(addonName)s”由于违反 Mozilla 政策，已被限制" ],
      "This add-on is restricted for violating Mozilla policies":[ "此附加组件由于违反 Mozilla 政策，已被限制" ],
      "%(addonName)s is blocked for violating Mozilla policies":[ "“%(addonName)s”由于违反 Mozilla 政策，已被阻止" ],
      "This add-on is blocked for violating Mozilla policies":[ "此附加组件由于违反 Mozilla 政策，已被阻止" ],
      "Why did this happen?":[ "为什么会出现此情况？" ],
      "This extension, theme, or plugin violates %(startLink)sMozilla's add-on policies%(endLink)s.":[ "此扩展、主题或插件违反了 %(startLink)sMozilla 的附加组件政策%(endLink)s。" ],
      "What does this mean?":[ "这是什么意思？" ],
      "Until the violation is resolved, this add-on won't be available for download from addons.mozilla.org. If it’s already installed, it will be disabled and users will be informed about the violation. They may choose to enable the add-on again at their own risk.":[ "在消除违规情况前，addons.mozilla.org 将不再提供此附加组件的下载，已经安装的附加组件也将被禁用，并告知用户此违规情况。用户可选择自担风险，重新启用此附加组件。" ],
      "Until the violation is resolved, this add-on won't be available for download from addons.mozilla.org. It will be automatically disabled and no longer usable in Firefox.":[ "在消除违规情况前，addons.mozilla.org 将不再提供此附加组件的下载。其将被自动禁用，且无法再在 Firefox 上使用。" ],
      "How does Mozilla enforce its policies?":[ "Mozilla 如何执行其政策？" ],
      "When Mozilla becomes aware of add-ons, plugins, or other third-party software that seriously compromise Firefox security, stability, or performance and meet %(criteriaStartLink)scertain criteria%(criteriaEndLink)s, the software may be blocked or restricted from general use. For more information, please read %(supportStartLink)sthis support article%(supportEndLink)s.":[ "当 Mozilla 发现某个附加组件、插件或第三方软件严重威胁 Firefox 的安全性、稳定性或性能，并且符合%(criteriaStartLink)s特定标准%(criteriaEndLink)s时，该软件可能被阻止或限制正常使用。有关更多信息，请参阅%(supportStartLink)s这篇支持文章%(supportEndLink)s。" ],
      "View block request":[ "查看屏蔽请求" ],
      "All extension categories":[ "所有扩展分类" ],
      "All theme categories":[ "所有主题分类" ],
      "Themes in %(categoryName)s":[ "%(categoryName)s 中的主题" ],
      "Extensions in %(categoryName)s":[ "%(categoryName)s 中的扩展" ],
      "Do you really want to delete this collection?":[ "您确定要删除这个收藏集吗？" ],
      "Delete this collection":[ "删除这个收藏集" ],
      "You reported this collection":[ "您已举报此收藏集" ],
      "We have received your report. Thanks for letting us know about your concerns with this collection.":[ "我们已收到您的报告。感谢您对此的关注。" ],
      "Report this collection":[ "举报此收藏集" ],
      "Log in to create a collection":[ "登录以创建一个收藏集" ],
      "Log in to edit this collection":[ "登录以编辑此收藏集" ],
      "First, create your collection. Then you can add extensions and themes.":[ "首先，请创建您的收藏集，然后您可以向其中添加扩展和主题。" ],
      "Search for extensions and themes to add to your collection.":[ "在您的收藏集中搜索扩展和主题。" ],
      "Download and create Firefox collections to keep track of favorite extensions and themes. Explore the %(collectionName)s—%(collectionDescription)s.":[ "下载并创建 Firefox 收藏集，以记录您最爱的的扩展与主题。探索 %(collectionName)s——%(collectionDescription)s。" ],
      "Download and create Firefox collections to keep track of favorite extensions and themes. Explore the %(collectionName)s.":[ "下载并创建 Firefox 收藏集，以记录您最爱的的扩展与主题。探索 %(collectionName)s。" ],
      "Submit feedback or report a collection to Mozilla":[ "向 Mozilla 提交反馈或报告某个收藏集" ],
      "by %(authorName)s":[ "作者 %(authorName)s" ],
      "Report this collection to Mozilla":[ "向 Mozilla 报告这个收藏集" ],
      "Send some feedback about the collection":[ "发送有关收藏集的反馈" ],
      "Report the collection because it's illegal or incompliant":[ "报告此收藏集非法或不合规" ],
      "My collections":[ "我的收藏集" ],
      Collections:[ "收藏集" ],
      "Log in to view your collections":[ "登录以查看您的收藏集" ],
      "Collections make it easy to keep track of favorite add-ons and share your perfectly customized browser with others.":[ "收藏集可以方便存下您喜欢的附加组件，让您可以与朋友分享彰显您个性的浏览器。" ],
      "Create a collection":[ "创建收藏集" ],
      "You do not have any collections.":[ "您没有任何收藏。" ],
      Music:[ "音乐" ],
      Seasonal:[ "季节" ],
      "Firefox for Android extensions":[ "Firefox for Android 的扩展" ],
      "Personalize Firefox for Android with powerful extensions.":[ "借助强大的扩展个性化 Firefox for Android。" ],
      "See more recommended extensions":[ "更多推荐扩展" ],
      "Explore all Android extensions":[ "发现所有 Android 扩展" ],
      "See more trending extensions":[ "更多热门扩展" ],
      "Change the way Firefox looks with themes.":[ "使用主题改变 Firefox 的外观。" ],
      "Download Firefox extensions and themes. They’re like apps for your browser. They can block annoying ads, protect passwords, change browser appearance, and more.":[ "下载 Firefox 扩展与主题，它们就像是您浏览器上的应用程序，可以屏蔽讨人厌的广告、保护密码、更改浏览器外观，还有更多功能。" ],
      Abstract:[ "抽象" ],
      Nature:[ "自然" ],
      "Film & TV":[ "影视" ],
      Scenery:[ "风景" ],
      "See more top rated extensions":[ "更多好评扩展" ],
      "See more recommended themes":[ "更多推荐主题" ],
      "See more trending themes":[ "更多热门主题" ],
      "See more top rated themes":[ "更多好评主题" ],
      "Download themes to change how Firefox looks. Tailor your experience to your tastes. Cute critters, evil robots, beautiful landscapes—thousands of options.":[ "下载主题来更改 Firefox 的外观。可根据自己的风格来定制您的体验，不论是可爱小动物、邪恶机器人，或是美丽风景——这里有数以千计的选择 。" ],
      "Download Firefox Extensions to add features that customize browsing. Protect passwords, find deals, enhance video, and block annoying ads with browser apps.":[ "下载 Firefox 扩展，添加功能来定制您的上网体验。通过浏览器的“应用程序”来保护密码、寻找购物折扣、增强看片体验、屏蔽讨人厌的广告。" ],
      "Change your browser's appearance. Choose from thousands of themes to give Firefox the look you want.":[ "为浏览器换身装扮。您可以挑选成千上万的主题，使 Firefox 变成您想要的样子。" ],
      "Explore powerful tools and features to customize Firefox and make the browser all your own.":[ "探索功能强大的工具与特性，让 Firefox 有你的风格。" ],
      "Explore all categories":[ "浏览所有分类" ],
      "Available for your locale":[ "您的区域设置可用的项目" ],
      "Dictionaries and Language Packs":[ "字典和语言包" ],
      "Download Firefox dictionaries and language pack extensions. Add a new language option to your browser spell-checker, or change the browser's interface language.":[ "下载 Firefox 字典与语言包。添加新的语言选项到您浏览器的拼写检查工具，或更改浏览器界面语言。" ],
      "Installing a dictionary add-on will add a new language option to your spell-checker, which checks your spelling as you type in Firefox.":[ "安装字典附加组件将为您的拼写检查器添加一个新的语言选项，拼写检查器会在您向 Firefox 输入时检查拼写。" ],
      "Language packs change your browser's interface language, including menu options and settings.":[ "语言包更改您的浏览器界面的语言，包括菜单、选项等。" ],
      "All Locales":[ "所有语言" ],
      "Locale Name":[ "语言名称" ],
      "Language Packs":[ "语言包" ],
      Dictionaries:[ "字典" ],
      "Submit feedback or report a review to Mozilla":[ "向 Mozilla 提交反馈或举报评论" ],
      "by %(userName)s, %(timestamp)s":[ "%(userName)s 发表于 %(timestamp)s" ],
      "Report this review to Mozilla":[ "向 Mozilla 举报此评论" ],
      "Report the review because it is illegal or incompliant":[ "举报此评论违法或违规" ],
      "Want to interact with addons.mozilla.org (AMO) programmatically? Check out the %(startAddonsServerDocumentation)sAdd-ons Servers documentation%(endAddonsServerDocumentation)s for details about the APIs used by AMO and the %(startAddonsManager)sAdd-ons Manager%(endAddonsManager)s.":[ "想以编程方式与 addons.mozilla.org（AMO）交互吗？请查看%(startAddonsServerDocumentation)s附加组件服务端文档%(endAddonsServerDocumentation)s，欢迎了解有关 AMO 和%(startAddonsManager)s附加组件管理器%(endAddonsManager)s所用 API 的详细信息。" ],
      "If you want to contribute but are not quite as technical, there are still ways to help:":[ "如果您想要贡献但缺乏相应技术，也有些方法来帮忙：" ],
      "Participate in our %(startLink)sforum%(endLink)s.":[ "参与我们的%(startLink)s论坛%(endLink)s。" ],
      "Leave feedback for your favorite add-ons. Add-on authors are more likely to improve their add-ons and create new ones when they know people appreciate their work.":[ "给您喜欢的附加组件提供反馈。如果附加组件的作者知道有人欣赏他的作品，将更有可能改进附加组件和创建新作品。" ],
      "Tell your friends and family that Firefox is a fast, secure browser that protects their privacy, and they can use add-ons to make it their own!":[ "告诉你的朋友和家人，Firefox 是一款快速、安全的浏览器，有助保护隐私，并且可使用附加组件充分个性化！" ],
      "To see more ways you can contribute to the add-on community, please visit our %(startLink)swiki%(endLink)s.":[ "欢迎看看 %(startLink)swiki%(endLink)s，了解您能如何为附加组件社区出力。" ],
      "Report an issue":[ "报告缺陷（Bug）" ],
      "About Firefox Add-ons":[ "关于 Firefox 附加组件" ],
      "If you find a problem with the site, we'd love to fix it. Please file an %(startIssueLink)sissue%(endIssueLink)s and include as much detail as possible.":[ "若网站有任何问题，我们很乐意修复。请提交%(startIssueLink)s问题%(endIssueLink)s，并提供尽可能多的信息。" ],
      "The official Mozilla site for downloading Firefox extensions and themes. Add new features and change the browser’s appearance to customize your web experience.":[ "Mozilla 用来下载 Firefox 扩展与主题的官方网站。可添加新功能、更改浏览器外观来定制您的上网体验。" ],
      "To report a security vulnerability for an extension, even if it is not hosted on this site, please file an %(startSecIssueLink)sissue%(endSecIssueLink)s on Bugzilla. All security vulnerability reports are %(startLink)sconfidential%(endLink)s.":[ "若要报告扩展的安全漏洞（即使其并非在此网站上托管），请到 Bugzilla %(startSecIssueLink)s提交问题%(endSecIssueLink)s。所有的安全漏洞报告均会%(startLink)s保持机密%(endLink)s。" ],
      "Get support":[ "获取支持" ],
      "If you would like to learn more about how to manage add-ons in Firefox, or need to find general Firefox support, please visit %(startSUMOLink)sSupport%(endSUMOLink)s Mozilla. If you don't find an answer there, you can %(startForumLink)sask on our community forum%(endForumLink)s.":[ "若您想要详细了解如何在 Firefox 中管理附加组件，或需要更广泛的 Firefox 技术支持，请访问 Mozilla %(startSUMOLink)s技术支持站%(endSUMOLink)s。若您无法在此网站找到合适的答案，您可以%(startForumLink)s在我们的社区论坛提问%(endForumLink)s。" ],
      "%(startLink)sInformation about how to contact Mozilla's add-ons team can be found here%(endLink)s.":[ "%(startLink)sMozilla 附加组件团队的联系方式可在这里找到%(endLink)s。" ],
      "Addons.mozilla.org (AMO), is Mozilla's official site for discovering and installing add-ons for the Firefox browser. Add-ons help you modify and personalize your browsing experience by adding new features to Firefox, enhancing your interactions with Web content, and changing the way your browser looks.":[ "Addons.mozilla.org（AMO）是 Mozilla 的官方网站，您可在此发现和安装用于 Firefox 浏览器的附加组件。通过为 Firefox 添加新特性、增强您与 Web 内容的交互与改变浏览器的外观，附加组件能帮您改进和个性化浏览体验。" ],
      "If you are looking for add-ons for Thunderbird or SeaMonkey, please visit %(startTBLink)saddons.thunderbird.net%(endTBLink)s or %(startSMLink)saddons.thunderbird.net/seamonkey%(endSMLink)s.":[ "如果您在寻找适用于 Thunderbird 或 SeaMonkey 的附加组件，请访问 %(startTBLink)saddons.thunderbird.net%(endTBLink)s 或 %(startSMLink)saddons.thunderbird.net/seamonkey%(endSMLink)s。" ],
      "A community of creators":[ "创作者社区" ],
      "The add-ons listed here are created by thousands of developers and theme designers from all over the world, ranging from individual hobbyists to large corporations. Some add-ons listed on AMO have been automatically published and may be subject to review by a team of editors once publicly listed.":[ "这里的附加组件为世界各地成千上万的开发者和主题设计师所打造，他们有的是个人业余爱好者，有的是大公司。AMO 上的某些附加组件是自动发布的，而公开发布后，这些附加组件可能会受到编辑团队的审核。" ],
      "Get involved":[ "参与进来" ],
      "Mozilla is a non-profit champion of the Internet, we build Firefox to help keep it healthy, open and accessible. Add-ons support user choice and customization in Firefox, and you can contribute in the following ways:":[ "Mozilla 是一个非营利的互联网拥护者，我们打造了 Firefox 来帮助保持互联网的健康、开放及人人可用。附加组件使 Firefox 可以为用户提供选择权与定制性，而您则可以通过以下方式作出贡献：" ],
      "%(startLink)sMake your own add-on%(endLink)s. We provide free hosting and update services and can help you reach a large audience of users.":[ "%(startLink)s制作你自己的附加组件%(endLink)s。我们提供免费的托管和更新服务，并能帮助你接触到大量的用户群体。" ],
      "Help improve this website. It's open source, and you can file bugs and submit patches. You can get started with a %(startGoodFirstBugLink)sgood first bug%(endGoodFirstBugLink)s or view all open issues for AMO’s %(startAddonsServerRepoLink)sserver%(endAddonsServerRepoLink)s and %(startAddonsFrontendRepoLink)sfrontend%(endAddonsFrontendRepoLink)s on Github.":[ "帮助改进本网站。它是一个开源软件，您可以提报缺陷和提交修复补丁。建议您从 %(startGoodFirstBugLink)sgood first bug%(endGoodFirstBugLink)s 开始，或查看 Github 上的 AMO 的%(startAddonsServerRepoLink)s服务器%(endAddonsServerRepoLink)s和%(startAddonsFrontendRepoLink)s前端%(endAddonsFrontendRepoLink)s。" ],
      "Include your own or anyone else’s email, phone number, or other personal details.":[ "包含您自己或他人的电子邮件地址、电话号码或其他个人信息。" ],
      "Post reviews for an add-on you or your organization wrote or represent.":[ "为您或您的组织所撰写或代表的附加组件发表评价。" ],
      "Criticize an add-on for something it’s intended to do. For example, leaving a negative review of an add-on for displaying ads or requiring data gathering, when that is the intended purpose of the add-on, or the add-on requires gathering data to function.":[ "批评附加组件的本来意图。例如，附加组件的功能预期将会或者无法避免显示广告或进行数据收集。" ],
      "Frequently Asked Questions about Reviews":[ "有关评价的常见问题" ],
      "How can I report a problematic review?":[ "我能报告一个有问题的评价吗？" ],
      "Please report or flag any questionable reviews by clicking the \"Report this review\" and it will be submitted to the site for moderation. Our moderation team will use the Review Guidelines to evaluate whether or not to delete the review or restore it back to the site.":[ "请点击“举报此评价”来报告可能有问题的评价，这会将其提交给网站的审核团队。我们的审核小组将参照“评价指南”来评估是否删除评价将其还原。" ],
      "I'm an add-on author, can I respond to reviews?":[ "我是一个附加组件的作者，我可以回应评价吗？" ],
      "Yes, add-on authors can provide a single response to a review. You can set up a discussion topic in our %(startLink)sforum%(endLink)s to engage in additional discussion or follow-up.":[ "是的，附加组件作者可以对一条评价发表一次回应。您可以在我们的%(startLink)s论坛%(endLink)s中开设一个主题，以进行持续性讨论。" ],
      "I'm an add-on author, can I delete unfavorable reviews or ratings?":[ "我是一个附加组件的作者，我可以删除负面的评价或评分吗？" ],
      "In general, no. But if the review did not meet the review guidelines outlined above, you can click \"Report this review\" and have it moderated. If a review included a complaint that is no longer valid due to a new release of your add-on, we may consider deleting the review.":[ "一般来说，不会。但如果评价不遵守上述指南，您可以点击“举报此评价”使其接受审核。如果评价已因新版本附加组件而失去效力，我们会考虑删除该评价。" ],
      "Review Guidelines":[ "评价指南" ],
      "Guidelines, tips, and Frequently Asked Questions to leave a review for the extensions and themes you’ve downloaded and used on Firefox.":[ "对您为 Firefox 下载使用的扩展与主题留下评价时的指南、小提示、常见问题。" ],
      "Add-on reviews are a way for you to share your opinions about the add-ons you’ve installed and used. Our review moderation team reserves the right to refuse or remove any review that does not comply with these guidelines.":[ "您可以使用附加组件评价来分享对已安装和已使用附加组件的感受。我们的审核小组保留拒绝和删除不符合“评价指南”的评价的权利。" ],
      "Tips for writing a great review":[ "撰写绝佳评价的小提示" ],
      "Do:":[ "应当：" ],
      "Write like you are telling a friend about your experience with the add-on.":[ "撰写评价时，叙述风格应该像你对朋友阐述对它的感觉。" ],
      "Keep reviews concise and easy to understand.":[ "评价应该简洁易懂。" ],
      "Give specific and helpful details. For example:":[ "提供确切、有用的细节，例如：" ],
      "Did the add-on work as you expected it to?":[ "此附加组件的效果如您预期吗？" ],
      "What features did you like or dislike?":[ "您喜欢或者不喜欢哪些功能？" ],
      "Was it useful?":[ "它有用吗？" ],
      "Was it easy to use?":[ "它易于使用吗？" ],
      "Will you continue to use this add-on?":[ "您将继续使用此附加组件吗？" ],
      "Take a moment to read your review before submitting it to minimize typos.":[ "花点时间阅读您的评价，然后再提交它。" ],
      "Don't:":[ "不要：" ],
      "Submit one-word reviews such as \"Great!\", \"wonderful,\" or \"bad\".":[ "只表达感受，例如：“很好”、“不错”或“不好用”。" ],
      "Post technical issues, support requests, or feature suggestions. Use the available support options for each add-on, if available. You can find them in the \"More information\" section in the sidebar on the add-on's detail page.":[ "发表技术性问题、支持请求或功能建议。请使用附加组件提供的支持选项（如果存在），您可以在附加组件详细信息页面中侧栏的“更多信息”部分找到支持方式。" ],
      "Write reviews for add-ons which you have not personally used.":[ "为您没有亲自尝试的附加组件发表评价。" ],
      "Use profanity, sexual language or language that can be construed as hateful.":[ "使用亵渎、性意味或其他可能构成伤害的言语。" ],
      "Include HTML, links, source code or code snippets. Reviews are meant to be text only.":[ "包含 HTML、链接、代码。请只在评论中留下文字内容。" ],
      "Make false statements, disparage add-on authors or personally insult them.":[ "作出虚假的陈述、贬低或者侮辱附加组件的作者或任何个体。" ],
      "Add-ons tagged with %(tag)s":[ "带有 %(tag)s 标签的附加组件" ],
      "Submit feedback or report a user to Mozilla":[ "向 Mozilla 提交反馈或举报用户" ],
      "User since":[ "注册时间" ],
      "Report this user to Mozilla":[ "向 Mozilla 报告此用户" ],
      "Send some feedback about the user profile":[ "发送有关用户资料的反馈" ],
      "Report the user profile because it's illegal or incompliant":[ "举报用户资料违法或违规" ],
      "My reviews":[ "我所发表的评价" ],
      "The profile of %(user)s, a Firefox extension and theme author. Find other apps by %(user)s, including average ratings, tenure, and the option to report issues.":[ "Firefox 扩展与主题作者 %(user)s 的个人资料。寻找其他由 %(user)s 开发的应用程序，包含平均得分、使用时长以及反馈问题的选项。" ],
      "The profile of %(user)s, Firefox extension author. Find other extensions by %(user)s, including average ratings, tenure, and the option to report issues.":[ "Firefox 扩展作者 %(user)s 的个人资料。寻找其他由 %(user)s 开发的扩展，包含平均得分、使用时长以及反馈问题的选项。" ],
      "The profile of %(user)s, Firefox theme author. Find other themes by %(user)s, including average ratings, tenure, and the option to report issues.":[ "Firefox 主题作者 %(user)s 的个人资料。寻找其他由 %(user)s 开发的主题，包含平均得分、使用时长以及反馈问题的选项。" ],
      "User Avatar":[ "用户头像" ],
      "Add-ons developer":[ "附加组件开发者" ],
      "Theme artist":[ "主题艺术家" ],
      "User Profile for %(user)s":[ "%(user)s 的用户资料" ],
      "User Profile":[ "用户资料" ],
      Occupation:[ "职业" ],
      "Number of add-ons":[ "附加组件数量" ],
      "Average rating of developer’s add-ons":[ "开发者的附加组件平均得分" ],
      Biography:[ "自我介绍" ],
      "Edit profile":[ "编辑个人资料" ],
      "Admin user":[ "管理员用户" ],
      "Picture successfully deleted":[ "照片删除成功" ],
      "Tell users a bit more information about yourself. Most fields are optional, but they'll help other users get to know you better.":[ "请向其他用户更详细地介绍一下您。大多数字段为选填，但能帮助其他人更好地了解您。" ],
      "Tell users a bit more information about this user. Most fields are optional, but they'll help other users get to know %(userName)s better.":[ "请向其他用户更详细地介绍一下这位用户。大多数字段为选填，但能帮助其他人更好地了解 %(userName)s。" ],
      "Introduce yourself to the community if you like":[ "可以的话欢迎向整个社区介绍一下您自己" ],
      "Introduce %(userName)s to the community":[ "介绍 %(userName)s 给社区成员认识" ],
      "Log in to edit the profile":[ "登录以编辑个人资料" ],
      "Creating your profile…":[ "正在创建您的个人资料…" ],
      "Create My Profile":[ "创建个人资料" ],
      "Updating your profile…":[ "正在更新您的个人资料…" ],
      "Update My Profile":[ "更新我的个人资料" ],
      "Updating profile…":[ "更新个人资料…" ],
      "Update Profile":[ "更新个人资料" ],
      "View user's profile":[ "查看用户个人资料" ],
      "Edit user's profile":[ "编辑用户个人资料" ],
      Account:[ "账户" ],
      "Account for %(userName)s":[ "%(userName)s 的账户" ],
      "Email Address":[ "邮箱地址" ],
      "Email address cannot be changed here":[ "邮箱地址不可在此处更改" ],
      "You can change your email address on Mozilla accounts. %(startLink)sNeed help?%(endLink)s":[ "您可以在 Mozilla 账户页面更改邮箱地址。%(startLink)s需要帮助？%(endLink)s" ],
      "Manage Mozilla accounts…":[ "管理 Mozilla 账户…" ],
      Profile:[ "用户资料" ],
      "This field is required":[ "此字段必填" ],
      "Display Name *":[ "显示名称 *" ],
      "This URL will only be visible for users who are developers.":[ "此网址只会给其他开发者看到。" ],
      "Some HTML supported: %(htmlTags)s. Links are forbidden.":[ "支持部分 HTML：%(htmlTags)s。不允许使用链接。" ],
      Notifications:[ "通知" ],
      "From time to time, Mozilla may send you email about upcoming releases and add-on events. Please select the topics you are interested in.":[ "Mozilla 可能会不时向您寄送电子邮件，告诉您即将发布的版本和附加组件新动向。请选择您感兴趣的话题。" ],
      "From time to time, Mozilla may send this user email about upcoming releases and add-on events. Please select the topics this user may be interested in.":[ "Mozilla 可能会不时向此用户寄送电子邮件，告诉他有关即将发布的版本和附加组件新动向。请选择此用户可能感兴趣的话题。" ],
      "Mozilla reserves the right to contact you individually about specific concerns with your hosted add-ons.":[ "Mozilla 保留使用此信息与您联络，就您上架的附加组件进行询问的权利。" ],
      "Delete My Profile":[ "删除我的个人资料" ],
      "Delete Profile":[ "删除个人资料" ],
      "IMPORTANT: Deleting your Firefox Add-ons profile is irreversible.":[ "重要：此操作无法撤销，您将删除您在 Firefox 附加组件网站的个人资料（账号）。" ],
      "IMPORTANT: Deleting this Firefox Add-ons profile is irreversible.":[ "重要：此操作无法撤销，您将删除在 Firefox 附加组件网站的个人资料（账号）。" ],
      "Your data will be permanently removed, including profile details (picture, user name, display name, location, home page, biography, occupation), notification preferences, reviews, and collections.":[ "将永久移除您的数据，包括详细个人资料（头像、用户名、显示名称、地理位置、首页、自传、职业）、通知首选项、评论和收集。" ],
      "The user’s data will be permanently removed, including profile details (picture, user name, display name, location, home page, biography, occupation), notification preferences, reviews, and collections.":[ "将永久移除该用户的数据，包括详细个人资料（头像、用户名、显示名称、地理位置、首页、自传、职业）、通知首选项、评论和收集。" ],
      "If you authored any add-ons they will also be deleted, unless you share ownership with other authors. In that case, you will be removed as an author and the remaining authors will maintain ownership of the add-on.":[ "若您是任何附加组件的唯一作者，这些附加组件也将被删除。若您与其他作者共享附加组件的所有权，则将从该附加组件的作者名单中移除，其他的作者将继续拥有该附加组件。" ],
      "If the user authored any add-ons they will also be deleted, unless ownership is shared with other authors. In that case, the user will be removed as an author and the remaining authors will maintain ownership of the add-on.":[ "若用户是任何附加组件的唯一作者，这些附加组件也将被删除。若该用户与其他作者共享附加组件的所有权，则将从该附加组件的作者名单中移除，其他的作者将继续拥有该附加组件。" ],
      "When you use this email address to log in again to addons.mozilla.org, your profile on Firefox Add-ons will not have access to any of its previous content.":[ "当您再次使用此电子邮件地址登录 addons.mozilla.org 时，也将无法访问 Firefox 附加组件网站先前账户的内容。" ],
      Unsubscribe:[ "取消订阅" ],
      "You are successfully unsubscribed!":[ "您已成功退订！" ],
      "The email address %(strongStart)s%(email)s%(strongEnd)s will no longer get messages when:":[ "当以下情况时电子邮件地址 %(strongStart)s%(email)s%(strongEnd)s 将不再收到信息：" ],
      "You can edit your notification settings by %(linkStart)sediting your profile%(linkEnd)s.":[ "您可以通过%(linkStart)s编辑您的个人资料%(linkEnd)s来调整通知设置。" ],
      "(no name)":[ "（无名称）" ],
      "%(application)s %(minVersion)s and later":[ "%(application)s %(minVersion)s 及更高版本" ],
      "%(application)s %(minVersion)s to %(maxVersion)s":[ "%(application)s %(minVersion)s 至 %(maxVersion)s" ],
      "Works with %(listOfApplicatonsAndVersions)s":[ "适用于 %(listOfApplicatonsAndVersions)s" ],
      "Installation aborted because the add-on appears to be corrupt.":[ "安装中止，因为附加组件似乎已损坏。" ],
      "Installation failed. Please try again.":[ "安装失败。请重试。" ],
      "Download failed. Please check your connection.":[ "下载失败。请检查您的网络连接。" ],
      "An unexpected error occurred during installation.":[ "安装时发生意外错误。" ],
      "An unexpected error occurred during uninstallation.":[ "卸载时发生意外错误。" ],
      "An unexpected error occurred.":[ "发生意外错误。" ],
      "stay up-to-date with news and events relevant to add-on developers (including the about:addons newsletter)":[ "关注与附加组件开发者有关的最新消息和动向（包括 about:addons 的新变化）" ],
      "Mozilla needs to contact me about my individual add-on":[ "Mozilla 需要就我自己的附加组件联系我" ],
      "new add-ons or Firefox features are available":[ "新附加组件或 Firefox 特性现在可用" ],
      "someone writes a review of my add-on":[ "有人给我的附加组件写了评价" ],
      "an add-on developer replies to my review":[ "附加组件开发者回复了我的评价" ],
      "my add-on is reviewed by a reviewer":[ "我的附加组件已被审核员审核" ],
      "my add-on's compatibility cannot be upgraded":[ "无法升级我的附加组件的兼容性" ],
      "my add-on's compatibility is upgraded successfully":[ "我的附加组件的兼容性升级成功" ],
      "Official add-on built by Mozilla Firefox. Meets security and performance standards.":[ "由 Mozilla Firefox 构建的官方附加组件，符合安全和性能标准。" ],
      "Firefox only recommends add-ons that meet our standards for security and performance.":[ "Firefox 只推荐符合我们的安全和性能标准的附加组件。" ] } },
  _momentDefineLocale:function anonymous(
) {

      // By requiring this module, the new locale is defined and
      // registered internally for moment.js
      require('moment/locale/zh-cn');
},
  _cacheBust:"2018.08.02" }